<!-- 時間帯マスタ　詳細画面 -->
<style src="@/assets/css/admin_parts.css" type="text/css" media="all" scoped></style>
<template>
	<div class="contents" id="wtmzn">
		<!-- ▽  -->
		<section id="mainContent">
			<h2>時間帯マスタ<span>詳細</span></h2>
			<ul class="contntMenu">
				<li class="onCancel" v-on:click="onCancel">戻る</li>
			</ul>
			<!-- ▽  -->
			<section class="inputArea">
				<div class="btnLst">
					<button class="confBtn" v-on:click="onConfirmUpdateModalOpen">更新</button>
				</div>
				<table class="inputTbl">
					<thead>
						<tr>
							<th>項目名称</th>
							<td>登録内容</td>
						</tr>
					</thead>
					<tbody>
						<tr>
							<th>名称</th>
							<td><input type="text" v-model="singleTMZN.ZNNM" placeholder="名称"></td>
						</tr>
						<tr>
							<th>受付時間</th>
							<td class="time">
								<input type="text" v-model.number="singleTMZN.STHH" maxlength="2" placeholder="XX">：
								<input type="text" v-model.number="singleTMZN.STMM" maxlength="2" placeholder="XX">
							</td>
						</tr>
					</tbody>
				</table>
			</section>
			<!-- △  END -->
		</section>
		<!-- △ mainContents END -->
		<!-- モーダルWindow S -->
		<modalWindow v-show="modal.validationError.isShow" v-on:close="onValidationErrorModalClose">
			<dt slot="modal-header">入力エラー</dt>
			<dd slot="modal-body">
				<errorMessageBox :errorMessages="modal.validationError.messages"></errorMessageBox>
			</dd>
			<dd slot="modal-footer"><a href="javascript:void(0)" v-on:click="onValidationErrorModalClose">閉じる</a></dd>
		</modalWindow>
		<!-- モーダルWindow E -->
		<!-- モーダルWindow S -->
		<modalWindow v-show="modal.systemError.isShow" v-on:close="onSystemErrorModalClose">
			<dt slot="modal-header">システムエラー</dt>
			<dd slot="modal-body">
				<errorMessageBox :errorMessages="modal.systemError.messages"></errorMessageBox>
			</dd>
			<dd slot="modal-footer"><a href="javascript:void(0)" v-on:click="onSystemErrorModalClose">閉じる</a></dd>
		</modalWindow>
		<!-- モーダルWindow E -->
		<!-- モーダルWindow S -->
		<modalWindow v-show="modal.confirmUpdate.isShow" v-on:close="onConfirmUpdateModalClose">
			<dt slot="modal-header">確認</dt>
			<dd slot="modal-body">
			 <errorMessageBox :errorMessages="modal.confirmUpdate.messages"></errorMessageBox>
			 <ul class="btnLst">
					<li><button v-on:click="onUpdate">OK</button></li>
					<li><button v-on:click="onUpdateCancel">キャンセル</button></li>
				</ul>
			</dd>
		</modalWindow>
	</div>
</template>

<script>
	import { WTMZNDetailApi } from '@/api'
	import { WTMZNDetailUpdateApi } from '@/api'
	import * as types from '@/store/mutation-types'
	import * as ErrorCodes from '@/components/Utility/error-codes'
	import ErrorMessageBox from '@/components/Utility/ErrorMessageBox'
	import ModalWindow from '@/components/Utility/ModalWindow'
	import * as UtilityConsoleLog from '@/components/Utility/UtilityConsoleLog'

	export default {
		name: 'MasterWTMZNDetail',
		// 使用コンポーネント
		components: {
			// エラーメッセージ
			errorMessageBox: ErrorMessageBox,
			// モーダルウィンドウ
			modalWindow: ModalWindow,
		},
		data() {
			return {
				singleTMZN: {
					// 時間帯名称
					ZNNM: '',
					// 開始 時
					STHH: 0,
					// 開始 分
					STMM: 0
				},
				// モーダルウィンドウ
				modal: {
					validationError: {
						messages: [],
						isShow: false
					},
					systemError: {
						messages: [
							'システムエラーです。',
							'内容をもう一度ご確認ください。'
						],
						isShow: false
					},
					confirmUpdate: {
						messages: [
							'更新しますか？'
						],
						isShow: false
					},
				}
			}
		},
		created: function () {
			UtilityConsoleLog.consoleLog('MasterWTMZNDetail::created Start')

			var tempircd = this.$store.state.auth.ircd

			var temptmzn = this.$store.state.adminUserChoice.MasterWTMZN.tmzn

			// 非同期通信
			WTMZNDetailApi.Detail({
				token: this.$store.state.auth.token,
				ircd: tempircd,
				tmzn: temptmzn
			}).then(({ responce }) => {

					if (responce.data.errorCode == ErrorCodes.ERRORCODE_DEFAULT) {

						this.singleTMZN = responce.data.singleTMZN

					} else if (responce.data.errorCode == ErrorCodes.ERRORCODE_SIMPLEITEM
						|| responce.data.errorCode == ErrorCodes.ERRORCODE_SYSTEM
						|| responce.data.errorCode == ErrorCodes.ERRORCODE_DB) {
						// システム、DBエラー時
						this.onSystemErrorModalOpen()
					}

				}).catch(() => {
					// システムエラー時
					this.onSystemErrorModalOpen()
				}).finally(() => {
					UtilityConsoleLog.consoleLog('MasterWTMZNDetail::created End')
				})
		},
		methods: {
			onUpdate: function () {
				UtilityConsoleLog.consoleLog("MasterWTMZNDetail::onUpdate Start")

				var tempircd = this.$store.state.auth.ircd
				var temptmzn = this.$store.state.adminUserChoice.MasterWTMZN.tmzn
				var tempznnm = this.singleTMZN.ZNNM
				var tempsthh = this.checkNumber(this.singleTMZN.STHH)
				var tempstmm = this.checkNumber(this.singleTMZN.STMM)

				WTMZNDetailUpdateApi.DetailUpdate({
					token: this.$store.state.auth.token,
					ircd: tempircd,
					tmzn: temptmzn,
					znnm: tempznnm,
					sthh: tempsthh,
					stmm: tempstmm
				}).then(({ responce }) => {

					if (responce.data.errorCode == ErrorCodes.ERRORCODE_DEFAULT) {

						//更新確認モーダルを閉じる
						this.onConfirmUpdateModalOpen()
						//更新完了モーダルを開く
						this.$router.push("/MasterWTMZNDetailUpdate")

					} else if (responce.data.errorCode == ErrorCodes.ERRORCODE_SIMPLEITEM
						|| responce.data.errorCode == ErrorCodes.ERRORCODE_SYSTEM
						|| responce.data.errorCode == ErrorCodes.ERRORCODE_DB) {
						// システム、DBエラー時
						this.onSystemErrorModalOpen()
						//入力項目でのエラー
					} else if (responce.data.errorCode == ErrorCodes.ERRORCODE_INPUTSIMPLEITEM) {
						this.onValidationErrorModalOpen(responce.data.errorMessagesList)
					}

				}).catch(() => {
					// システムエラー時
					this.onSystemErrorModalOpen()
				}).finally(() => {
					UtilityConsoleLog.consoleLog('MasterWTMZNDetail::onUpdate End')
				})
			},
			//一覧表示画面に戻る
			onCancel: function () {
				UtilityConsoleLog.consoleLog("MasterWTMZNDetail::onCancel Start")

				this.$store.commit(types.ADMIN_USERCHOICE_WTMZN_LISTTODETAIL, {})

				this.$router.push("/MasterWTMZNList")

				UtilityConsoleLog.consoleLog("MasterWTMZNDetail::onCancel End")
			},
			// Number型がString型になっていた場合数値に直して返す
			checkNumber: function (value0) {

				UtilityConsoleLog.consoleLog('MasterWTMZNDetail::checkNumber Start')

				var tempType = typeof value0
				var tempValue = 0

				if (tempType == 'number') {
					tempValue = value0
				} else {

					var regexp = new RegExp(/^[0-9]+(\.[0-9]+)?$/)
					var flagNumber = regexp.test(value0)

					// 文字列型の数値ではないとき
					if (!flagNumber) {
						tempValue = -1
					} else {
						tempValue = Number(value0)
					}
				}

				UtilityConsoleLog.consoleLog('MasterWTMZNDetail::checkNumber End')

				return tempValue
			},
			// 登録ボタン押下時の入力エラー 
			validationOnUpdate: function () {
				UtilityConsoleLog.consoleLog('MasterWTMZNRegister::onValidationErrorModalOpen Start')

				var errorMessages = []

				var tempSthh = this.checkNumber(this.singleTMZN.STHH)
				var tempStmm = this.checkNumber(this.singleTMZN.STMM)

				if(tempSthh == -1) {
					errorMessages.push('受付時間　時間は半角数字で入力してください。')
				}

				if(tempStmm == -1) {
					errorMessages.push('受付時間　分は半角数字で入力してください。')
				}

				UtilityConsoleLog.consoleLog('MasterWTMZNRegister::onValidationErrorModalOpen End')

				return errorMessages
			},
			// バリデーションエラーモーダルとしてエラーモーダルを開く
			// errorMessagesは文字列配列であること
			// errorMessages = [
			//  'エラーメッセージ'
			// ]
			onValidationErrorModalOpen: function (errorMessages) {
				UtilityConsoleLog.consoleLog('MasterWTMZNDetail::onValidationErrorModalOpen Start')

				var tempMessages = [
					'入力エラーです。',
					'以下の内容をもう一度ご確認ください'
				]
				
				errorMessages.forEach((item)=>{
					tempMessages.push(item)
				})

				this.modal.validationError.messages = tempMessages
				this.modalOpen('validationError')

				UtilityConsoleLog.consoleLog('MasterWTMZNDetail::onValidationErrorModalOpen End')
			},
			// バリデーションエラーモーダルとしてエラーモーダルを閉じる
			onValidationErrorModalClose: function () {
				UtilityConsoleLog.consoleLog('MasterWTMZNDetail::onValidationErrorModalClose Start')

				this.modalClose('validationError')

				UtilityConsoleLog.consoleLog('MasterWTMZNDetail::onValidationErrorModalClose End')
			},
			// システムエラーモーダルとしてエラーモーダルを開く
			onSystemErrorModalOpen: function () {
				UtilityConsoleLog.consoleLog('MasterWTMZNDetail::onSystemErrorModalOpen Start')

				this.modalOpen('systemError')

				UtilityConsoleLog.consoleLog('MasterWTMZNDetail::onSystemErrorModalOpen End')
			},
			// システムエラーモーダルウィンドウの閉じるボタン
			onSystemErrorModalClose: function () {
				UtilityConsoleLog.consoleLog('MasterWTMZNDetail::onSystemErrorModalClose Start')

				this.modalClose('systemError')
				this.$router.push("/AdminLogin")

				UtilityConsoleLog.consoleLog('MasterWTMZNDetail::onSystemErrorModalClose End')
			},
			// 更新確認モーダルを開く
			onConfirmUpdateModalOpen: function () {
				UtilityConsoleLog.consoleLog('MasterWTMZNDetail::onConfirmUpdateModalOpen Start')

				// エラーチェック
				var tempErrorMessages = this.validationOnUpdate()

				if(tempErrorMessages.length > 0) {
					this.onValidationErrorModalOpen(tempErrorMessages)
					return
				}

				this.modalOpen('confirmUpdate')

				UtilityConsoleLog.consoleLog('MasterWTMZNDetail::onConfirmUpdateModalOpen End')
			},
			// 更新確認モーダルを閉じる
			onConfirmUpdateModalClose: function () {
				UtilityConsoleLog.consoleLog('MasterWTMZNDetail::onConfirmUpdateModalClose Start')

				this.modalClose('confirmUpdate')

				UtilityConsoleLog.consoleLog('MasterWTMZNDetail::onConfirmUpdateModalClose End')
			},
			// 更新確認モーダルで表示画面に戻る
			onUpdateCancel: function () {
				UtilityConsoleLog.consoleLog("MasterWTMZNDetail::onUpdateCancel Start")

				this.modalClose('confirmUpdate')

				UtilityConsoleLog.consoleLog("MasterWTMZNDetail::onUpdateCancel End")
			},
			// モーダルウィンドウを開く
			modalOpen: function (modalName) {
				UtilityConsoleLog.consoleLog('MasterWTMZNDetail::modalOpen Start')

				// すべてのモーダルを閉じる
				this.allModalClose()

				this.modal[modalName].isShow = true

				UtilityConsoleLog.consoleLog('MasterWTMZNDetail::modalOpen End')
			},
			// モーダルウィンドウを閉じる
			modalClose: function (modalName) {
				UtilityConsoleLog.consoleLog('MasterWTMZNDetail::modalClose Start')

				this.modal[modalName].isShow = false

				UtilityConsoleLog.consoleLog('MasterWTMZNDetail::modalClose End')
			},
			// 全てのモーダルを閉じる
			allModalClose: function() {  
				for(var key in this.modal) {
					this.modal[key].isShow = false
				}
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/Admin/Master/WTMZN/MasterWTMZNDetail.vue